import { makeStyles } from '@material-ui/core';

const KENDO_DATA_GRID_SHELL_ROW_HEIGHT = 46;
export const KENDO_DATA_GRID_SHELL_EMPTY_HEIGHT = 92;

export default makeStyles({
  grid: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',

    '& table': {
      width: '100%',
      tableLayout: 'fixed',
      borderCollapse: 'separate',
      borderSpacing: 0,
    },
    '& .k-grid-container': {
      flex: 1,
    },
    '& .k-cell-inner': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .k-link': {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      textDecoration: 'none',
      color: 'inherit',
    },
    '& .k-column-title': {
      fontSize: 12,
      whiteSpace: 'normal',
    },
    '& td': {
      height: KENDO_DATA_GRID_SHELL_ROW_HEIGHT,
      boxSizing: 'border-box',
    },
  },
  empty: {
    maxHeight: '50vh',
  },
  withBottomButton: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottom: 'none',

    '& .k-grid-container': {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
  nonInteractive: {
    '& .k-grid-content td': {
      pointerEvents: 'none',
    },
  },
});
